import React, { Component } from "react"
import { connect } from "react-redux"
import { APP_URL } from "constants/ResourcesConstants"
import { isCurrentUserAdmin } from "app/modules/user/selectors"
import * as IntegrationSelectors from "app/modules/integrations/selectors"

const DISMISSED_GA_BANNER = "dismissed-ga-banner"

import './style.styl'

class GoogleAnalyticsBanner extends Component {

  state = {
    bannerDismissed: true
  }

  componentDidMount() {
    this.setState({bannerDismissed: localStorage.getItem(DISMISSED_GA_BANNER)}) 
  }
  

  render() {
    const { hasGoogleAnalyticsConnected, isAdmin } = this.props
    const { bannerDismissed } = this.state
    const showGoogleAnalyticsBanner = isAdmin && !hasGoogleAnalyticsConnected && !bannerDismissed
    if (!showGoogleAnalyticsBanner) {
        // hide banner if customer already has GA connected or has previously dismissed it.
        return null
    }
    const trackGoogleAnalyticsBannerClick = () => {
      window.analytics && window.analytics.track('GA Banner Click', {}) 
    }

    const dismissGoogleAnalyticsBanner = (e) => {
      e.preventDefault()
      localStorage.setItem(DISMISSED_GA_BANNER, true)
      this.setState({bannerDismissed: true})
      window.analytics && window.analytics.track('GA Banner Dismiss', {})
    }

    return (
      <div className={this.props.className}>
        {showGoogleAnalyticsBanner && (
          <div className="playbooks-ga-banner">
            <p>
            {' 👉 '}&nbsp;Tip: Get full funnel vision by connecting Google Analytics to Drift.
              <a
                onClick={trackGoogleAnalyticsBannerClick}
                href={`${APP_URL}/settings/setup/googleAnalytics`}
                target="_blank"
              >
                Connect
              </a>
              &nbsp;
              <a onClick={dismissGoogleAnalyticsBanner}>
                Dismiss
              </a>
            </p>
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  hasGoogleAnalyticsConnected: IntegrationSelectors.isGoogleAnalyticsConnected(state),
  isAdmin: isCurrentUserAdmin(state)
})

export default connect(
  mapStateToProps,
  null
)(GoogleAnalyticsBanner)



// WEBPACK FOOTER //
// ./src/scripts/components/GoogleAnalyticsBanner/index.js